
<lib-filters-component [filters_options]="filterInfo"></lib-filters-component>
<div>
<app-wa-table
  [isSortableFunc]="sortClass" [showCondition]="true" [headers]="headers" [isDataLoading]="loading"
  [areMoreData]="areMoreData()" (loadMore)="loadMore()" [data]="data" (headerClick)="changeSort($event)"
>
<ng-template [extraClass]="[]" app-column let-result>
    <div appCompetitionLink [isImage]="true"  appCompetitionLink [size]="110" [competitionId]="result.Id"></div>

</ng-template>
<ng-template [extraClass]="[]" app-column let-result>
    <a  appCompetitionLink [competitionId]="result.Id" class="uppertext-black">{{result.Name ? result.Name : result.NameShort}}</a>
    <div><lib-country-flag [id]="result.Country" [nameRight]="result.CountryName"></lib-country-flag>    </div>
</ng-template>
<ng-template [extraClass]="[]" app-column let-result>
  <ng-container *ngIf="result.DFrom !== result.DTo; else sameDate">
    <div class="date">{{result.DFrom | date : 'd MMMM yyyy'}} -</div>
    <div class="date">{{result.DTo | date :'d MMMM yyyy'}}</div>
    </ng-container>
    <ng-template #sameDate>
      <div class="date">
        {{result.DFrom | date : 'd MMMM yyyy'}}
      </div>
    </ng-template>

</ng-template>

<ng-template [extraClass]="['center-text']" app-column let-result>
    <div class="result__seed">{{result.QuRnk}}</div>
  </ng-template>
  <ng-template [extraClass]="['center-text']" app-column let-result>
    <app-position-medals [Rnk]="result.Rnk"></app-position-medals>
    </ng-template>
    <ng-template app-column let-result [extraClass]="['wa-table__cell--fit-left']">
        <div class="list-row-item__action" *ngIf="{data:data, showDetails:false} as detail" (click)="selectIndex(result.index)">
          <span class="plus-minus {{isIndexSelected(result.index) === false ? 'plus-minus--more' : 'plus-minus--less' }}">
          </span>
        </div>
      </ng-template>
      <ng-template app-column-responsive let-result [extraClass]="['td-36']">
          <div>
              <div appCompetitionLink [isImage]="true" [size]="75" [competitionId]="result.Id"></div>
          </div>
      </ng-template>
   <ng-template app-column-responsive let-result [extraClass]="['wa-table__cell--fit']">
      <div>
          <a appCompetitionLink [competitionId]="result.Id" class="uppertext-black-no-viewport">{{result.Name ? result.Name : result.NameShort}}</a>
          <div><lib-country-flag [id]="result.Country" [nameRight]="result.CountryName"></lib-country-flag>
          </div>
      </div>
      <div style="margin-bottom: 10px; margin-top:10px">
      <ng-container *ngIf="result.DFrom !== result.DTo; else sameDate">
      <div class="date border-separator_before">{{result.DFrom | date : 'd MMMM yyyy'}} -</div>
      <div class="date border-separator_after">{{result.DTo | date :'d MMMM yyyy'}}</div>
      </ng-container>
      <ng-template #sameDate>
        <div class="date border-separator_after border-separator_before">
          {{result.DFrom | date : 'd MMMM yyyy'}}
        </div>
      </ng-template>
    </div>
      <div class="uppertext-no-viewport" style="font-size: 13.6px;">Seed: <div class="uppertext-black-no-viewport" style="font-size: 1.2em;">{{result.QuRnk}}</div></div>
      <div><div style="font-size: 13.6px;" class="uppertext-no-viewport">    <app-position-medals [Rnk]="result.Rnk"></app-position-medals></div></div>

  </ng-template>
  <ng-template app-column-responsive let-result [extraClass]="['wa-table__cell--fit-right']">
      <div class="list-row-item__action" *ngIf="{data:data, showDetails:false} as detail" (click)="selectIndex(result.index)">
          <span class="plus-minus {{isIndexSelected(result.index) === false ? 'plus-minus--more' : 'plus-minus--less' }}">
          </span>
        </div>
  </ng-template>
      <ng-template app-row let-result>
          <td colspan="100%" class="wa-table__cell wa-table__cell--fit">
            <div *ngIf="isIndexSelected(result.index) === true" class="wa-table-details" [@slideInOut]="animationState">
              <ng-container *ngIf="result.Matches">
                <ng-container *ngIf="result.IsTeam !== 1; else teamTemplate">
                    <app-athlete-individual-results [matches]="result.Matches"></app-athlete-individual-results>
              </ng-container>

              <ng-template #teamTemplate>
                <app-athlete-team-results [members]="result.Members" [matches]="result.Matches"></app-athlete-team-results>
              </ng-template>
              </ng-container>
            </div>
          </td>
        </ng-template>
    <ng-template>

    </ng-template>
</app-wa-table>
</div>
